/**
 * Robust date parsing for Supabase analytics timestamps.
 * Handles variations: space vs T separator, +00 vs +00:00, microseconds.
 */
export const safeParseDate = (timestamp: string | Date | null | undefined): Date | null => {
  if (!timestamp) return null;
  if (timestamp instanceof Date) return isNaN(timestamp.getTime()) ? null : timestamp;

  // Normalize: replace space before time with 'T'
  let normalized = String(timestamp).replace(/^(\d{4}-\d{2}-\d{2}) (\d{2}:)/, '$1T$2');

  // Normalize short offset +00 → +00:00
  normalized = normalized.replace(/([+-]\d{2})$/, '$1:00');

  const date = new Date(normalized);
  return isNaN(date.getTime()) ? null : date;
};

export const toLocalDateStr = (d: Date): string => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};
